import { createFileRoute } from "@tanstack/react-router";

import { ResetPassword } from "@/views/login/reset-password";

export const Route = createFileRoute("/_guest/reset-password")({
  component: ResetPassword,
});
